import { AxiosResponse } from 'axios';
import { DEVICE_INFO_API_URL } from '../../../../config';
import deviceAxios from '../../../../utils/axios/device.axios';


const tryToFetchHistoryChats = (): Promise<AxiosResponse<any>> => {
    const url = `${DEVICE_INFO_API_URL}/chatbox/topics?type=HISTORY&dashboard=leo`;
    return deviceAxios.get<any>(url);
};

const tryToFetchSingleChat = (topicId: string): Promise<AxiosResponse<any>> => {
    return deviceAxios.get(`${DEVICE_INFO_API_URL}/chatbox/chat?topic=${topicId}`);
};

const tryToAddActionForChat = (id: string, data: any): Promise<AxiosResponse<any>> => {
    return deviceAxios.put(`${DEVICE_INFO_API_URL}/chatbox/messages/${id}/reaction`, data);
};

const tryToGetExistingTopic = (): Promise<AxiosResponse<any>> => {
    return deviceAxios.get(`${DEVICE_INFO_API_URL}/chatbox/chat`);
}

const tryToGetPaymentLink = (data: any): Promise<AxiosResponse<any>> => {
    return deviceAxios.post(`${DEVICE_INFO_API_URL}/leo/payments`, data);
}

const tryToGetChangeCardLink = (data: any): Promise<AxiosResponse<any>> => {
    return deviceAxios.put(`${DEVICE_INFO_API_URL}/leo/payments/change-card`, data);
}

export const HistoryChatsService = {
    tryToFetchHistoryChats,
    tryToGetPaymentLink,
    tryToFetchSingleChat,
    tryToAddActionForChat,
    tryToGetExistingTopic,
    tryToGetChangeCardLink
};